export default "__VITE_ASSET__DXrsqdk6__"